module.exports = __webpack_public_path__ + "static/img/cta-btn.81f2b6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c22/cta-btn.png
// module id = D7l+
// module chunks = 0